"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareUrl = void 0;
var types_1 = require("../types");
var getFacebookUrl_1 = __importDefault(require("./getFacebookUrl"));
var getLinkedinUrl_1 = __importDefault(require("./getLinkedinUrl"));
var getTwitterUrl_1 = __importDefault(require("./getTwitterUrl"));
var getWhatsAppUrl_1 = __importDefault(require("./getWhatsAppUrl"));
var getShareUrl = function (socialPlatform, _a) {
    var url = _a.url, quote = _a.quote, hashtag = _a.hashtag, title = _a.title, summary = _a.summary, source = _a.source, text = _a.text, hashtags = _a.hashtags, related = _a.related;
    switch (socialPlatform) {
        case types_1.SocialPlatforms.Facebook:
            return getFacebookUrl_1.default({ url: url, quote: quote, hashtag: hashtag });
        case types_1.SocialPlatforms.Linkedin:
            return getLinkedinUrl_1.default({ url: url, title: title, summary: summary, source: source });
        case types_1.SocialPlatforms.Twitter:
            return getTwitterUrl_1.default({ url: url, text: text, hashtags: hashtags, related: related });
        case types_1.SocialPlatforms.WhatsApp:
            return getWhatsAppUrl_1.default({ url: url, text: text });
    }
};
exports.getShareUrl = getShareUrl;
exports.default = exports.getShareUrl;
//# sourceMappingURL=getShareUrl.js.map